<template>
  <Tooltip :text="buttonTitle" :hide-delay="200">
    <button
      type="button"
      class="btn btn-sm nav-btn-icon debug-page-width-button"
      :aria-label="buttonTitle"
      @click="openDebugWindow"
    >
      <i class="bi bi-window"></i>
    </button>
  </Tooltip>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Tooltip from '@/components/tooltip.vue'

const { t } = useI18n()
const DEBUG_VIEWPORT_WIDTH = 1280
const DEBUG_WINDOW_NAME = 'ltms-debug-1280'
const buttonTitle = computed(() => t('buttonTitle'))
let debugWindow = null

function resizeDebugWindow() {
  if (!debugWindow || debugWindow.closed) {
    return
  }
  const chromeWidth = debugWindow.outerWidth - debugWindow.innerWidth
  debugWindow.resizeTo(DEBUG_VIEWPORT_WIDTH + chromeWidth, debugWindow.outerHeight)
}

function openDebugWindow() {
  if (debugWindow && !debugWindow.closed) {
    debugWindow.focus()
    resizeDebugWindow()
    return
  }

  const features = [
    `width=${DEBUG_VIEWPORT_WIDTH}`,
    `height=${Math.min(window.screen.availHeight || 900, 900)}`,
    'resizable=yes',
    'scrollbars=yes',
  ].join(',')

  debugWindow = window.open(window.location.href, DEBUG_WINDOW_NAME, features)
  debugWindow?.focus()

  setTimeout(resizeDebugWindow, 250)
}
</script>

<i18n>
{
  "ru": {
    "buttonTitle": "Debug: открыть страницу в отдельном окне 1280px"
  },
  "en": {
    "buttonTitle": "Debug: open the page in a separate 1280px window"
  }
}
</i18n>

<style scoped>
.debug-page-width-button {
  --bs-btn-color: inherit;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: transparent;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: transparent;
}
</style>
